import React from 'react'
import { useLocalstorageState } from 'rooks'
import { Banner } from '@mobi/component-library/Common/V2/Banner'
import { Button } from '@mobi/component-library/Common/V2/Buttons'
import { useBetAccount } from '@mobi/account/Areas/Deposit/Hooks/useBetAccount'
import { BetAccountKey, BetAccountRepo } from '@core/Data/Account/betAccount'
import { useLogon } from '@core/Utils/hooks/useLogon'
import { getFromRepo } from '@core/Utils/repository/getFromRepo'
import { autoOptInMarketingCommunications } from '@core/Areas/Account/MyPreferences/helpers/autoOptInMarketingCommunications'
import { accountBetAccountQueryKey } from '@core/Areas/Account/MyPreferences/constants'

export const MarketingOptInBanner: React.FC = () => {
  const { accountNumber, isLoggedIn } = useLogon()
  const isUserLoggedIn = accountNumber !== null && isLoggedIn === true

  if (!isUserLoggedIn) return null

  return <MarketingOptInBannerComponent accountNumber={accountNumber} />
}

// ===============
// Local Component
// ===============

const MarketingOptInBannerComponent: React.FC<{ accountNumber: number }> = ({ accountNumber }) => {
  const [dimissedTimestamp, setDismissedTimestamp] = useLocalstorageState<string | null>(
    `marketing-optin:${(accountNumber + 9).toString(36).toUpperCase()}:dismissed`,
    null
  )

  const { data } = useBetAccount({
    enabled: true,
    queryKey: accountBetAccountQueryKey,
    queryFn: () => getFromRepo(BetAccountRepo, BetAccountKey),
  })

  if (dimissedTimestamp) return null

  const marketingOptInInd = data?.MarketingOptInInd
  if (!marketingOptInInd) return null

  const hasOptedIn = marketingOptInInd === 'Y'
  if (hasOptedIn) return null

  const handleDismiss = () => {
    setDismissedTimestamp(new Date().toISOString())
  }

  const handleOptIn = () => {
    handleDismiss()
    autoOptInMarketingCommunications()
  }

  return (
    <Banner
      hideIcon
      type='warning'
      onClickDismiss={handleDismiss}
      data-testid='MarketingOptInBanner'
      text='Opt in now to receive promotions, bonus bets, marketing and offers by email, post, SMS, telephone and other direct means.'
      button={
        <Button
          size='sm'
          role='link'
          onClick={handleOptIn}
          color='secondary_outline'
          style={{ maxWidth: 'fit-content' }}
        >
          Opt In
        </Button>
      }
    />
  )
}
